import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';
import { JcLabel } from './JcLabel';


export interface JcFieldProps extends JcCommonProps {
  readonly children: React.ReactNode;
  readonly label: string;
}


export const JcField: React.FunctionComponent<JcFieldProps> = (props: JcFieldProps) => {
  const { label, children } = props;
  const commonProps = JcUtils.commonProps(props, ["jc-field"])

  // Associate the label with its control so `<label>` clicks focus the input and
  // tests/AT can find it by name (getByLabel). The single child control inherits
  // this id unless it already has one.
  const controlId = useJcFieldId();
  const control = React.isValidElement<{ id?: string }>(children)
    ? React.cloneElement(children, { id: children.props.id ?? controlId })
    : children;

  return <div {...commonProps}>
    <JcLabel className="jc-field-label" label={label} htmlFor={controlId} />
    {control}
  </div>;
}